angular.module('picmonic-common').factory('Schools', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v2/schools/:school_id/:resource',
      { school_id: '@school_id', resource: '@resource', limit: '@limit' },
      {
        query: { method: 'GET', isArray: true },
        get: { method: 'GET', isArray: false },
        search: { method: 'GET', isArray: true, url: '/api/v3/schools' },
        educators: {
          method: 'GET',
          isArray: true,
          url: '/api/v3/schools/:school_id/educators',
        },
      }
    );
  },
]);
